let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1Rd9w"), load("gGI57"), load("aZinD"), load("7XPb0")]).then(() => parcelRequire('e56cD'));